module.exports = __webpack_public_path__ + "img/mail-ic-popup-light.fe87f782.svg";